/* Version: 3.5.137 */
'use client';
import { noop } from './functions.js';

/**
 * Generate a function which provides an event object being emitted
 * from an interactive component to a user-provided handler.
 * This helps to keep the signature of each handler consistent.
 * @param {function} handler - user-provided event handler.
 */
var handle = function handle() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  return function (event, customValue) {
    var value;
    if (customValue !== undefined) {
      value = customValue;
    } else if (event && event.target) {
      value = event.target.type === 'checkbox' || event.target.type === 'radio' ? event.target.checked : event.target.value;
    } else ;
    return handler(value, event);
  };
};

export { handle as default };
